import { useState } from "react";
import { login } from "../../../Auth/userReducer.js";
import { informationCenter } from "../../../Auth/centerInformationReducer.js"
import { informationInstitute } from "../../../Auth/instituteInformationReducer.js"
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../Auth/userReducer";
import { useHistory, NavLink, Redirect } from "react-router-dom";
import { Form, Input, Button, Typography, message, Row, Col } from "antd";
import UserService from "../../../services/UserService.js";
import CenterService from "../../../services/CenterService.js";
import InstituteService from "../../../services/InstituteService.js";
import "./Login.css";
const { Title } = Typography;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function Login() {
  const user = useSelector(selectUser);
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const listRolesForCenter=[
    "Coordinador del centro",
    "Investigador",
    "Supervisor",
    "Asociado",
    "Consultor",
    "Estudiante",
  ];
  const listRolesForInstitute=[
    "Coordinador del instituto"
  ];
  const listRolesForANIDI=[
    "ANIDI - Director"
  ];

  if (user) {
    return <Redirect to={{ pathname: "/home" }} />;
  }

  const onFinish = (values) => {
    setIsLoading(true);
    message.loading({content:"Procesando...",key:"update"});
    UserService.login(values)
      .then((res) => {
        if (res.data?.success) {
          message.success({content:"Acceso aceptado", key:"update",duration:2});
          dispatch(login(res.data?.response));
          let userRol=res.data?.response?.rolName;
          let centerID=res.data?.response?.centerId;
          let instituteId=res.data?.response?.instituteId;
          loginByOption(userRol,centerID,instituteId)
          // CenterService.getCenterById(res?.data?.response?.centerId).then(res=>{
          //   let center=res?.data?.response;
          //   dispatch(informationCenter(center));
          // });

          history.push("/home");
        } else {
          message.error(res.data?.description);
          message.error({content:res.data?.description,key:"update",duration:4});
        }
      })
      .catch((e) => {
        console.log(e.message);
        message.error({content:e.message,key:"update",duration:4});
      });
    setIsLoading(false);
  };

  const checkRolIsValidate=(UserRol)=>{
    let isRolCenter=false;
    let isRolInstitute=false;
    let isRolANIDI=false;
    isRolCenter=listRolesForCenter.includes(UserRol)
    isRolInstitute=listRolesForInstitute.includes(UserRol)
    isRolANIDI=listRolesForANIDI.includes(UserRol)
    
    return {
      isRolCenter:isRolCenter,
      isRolInstitute:isRolInstitute,
      isRolANIDI:isRolANIDI,
    }
    
  }

  const loginByOption=async(userRol,centerId,instituteId)=>{
    let {isRolCenter,isRolInstitute}=checkRolIsValidate(userRol);
    let Center;
    if(isRolCenter){
      //await CenterService.getCenterById(res?.data?.response?.centerId).then(res=>{
      Center=await CenterService.getCenterById(centerId).then((res)=>{
        let center=res?.data?.response;
        dispatch(informationCenter(center));
        return center
      });
      // console.log("center",Center)
      if(Center.assignedInstitute){
        await InstituteService.getInstituteById(Center.instituteId).then((res)=>{
          let institute=res?.data?.response;
          dispatch(informationInstitute(institute));
          return institute
        })
      }
    }
    if(isRolInstitute){
      await InstituteService.getInstituteById(instituteId).then((res)=>{
        let institute=res?.data?.response;
        dispatch(informationInstitute(institute));
      })
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Row align="center" style={{ marginTop: "3em" }}>
        <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
          <Title>Ingresar</Title>
        </Col>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 18, offset: 0 }}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Form
            style={{ width: "60%" }}
            name="basic"
            {...formItemLayout}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: "Por favor ingresa tu correo electrónico!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Contraseña"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa tu contraseña!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            {/* <Row align="end" style={{ marginBottom: "1rem" }}>
                <Col>
                  <NavLink to="/email-reset-password">
                    {"Olvidé mi contraseña"}
                  </NavLink>
                </Col>
              </Row> */}

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: "15px" }}
                disabled={isLoading}
              >
                Ingresar
              </Button>
              <NavLink to="/email-reset-password">
                {"Olvidé mi contraseña"}
              </NavLink>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
}
